/*
 * @Author: EdwardYoung
 * @Date: 2017-08-29 14:32:43
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-08-29 15:15:37
 */

/**
 *
 * @param {Date} startTime 活动开始时间
 * function 判断活动是否过期
 */
function isActivityOntime (endTime) {
  let endDate = new Date(endTime).getTime()
  let currentDate = new Date().getTime()
  if (endDate >= currentDate) {
    return true
  } else {
    return false
  }
}

export {isActivityOntime}




// WEBPACK FOOTER //
// ./src/common/util/isActivityOntime.js